// extracted by mini-css-extract-plugin
export default {"supportContainer":"ChatButton_supportContainer--IGl","button":"ChatButton_button--iK3","hidden":"ChatButton_hidden--upq"};